import styled from "@emotion/styled";
import { MDSTextField } from "@/mds/components/forms/text-field";
import { MDSSelectMenuWithContent } from "@/mds/components/menu/select-menu";

export const StyledContainer = styled.div`
  position: relative;
  flex: 1;
`;

export const StyledTextField = styled(MDSTextField)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing["1"]};
  padding: ${({ theme }) => `${theme.spacing["1"]} ${theme.spacing["5"]}`};
  min-height: 40px;
`;

export const StyledSelectMenu = styled(MDSSelectMenuWithContent)`
  width: 100%;
  max-width: unset;
`;
